import { createSlice } from '@reduxjs/toolkit';

// interface SubTitleItem {
//     text: string;
//     start: number;
//     end: number;
//     isTranslated?: boolean;
//     transcriptionText?: string;
//     transcriptionWords?: { text: string; start: number; end: number }[];
// }

const FJCutVideoSlice = createSlice({
    name: 'FJCutVideo',
    initialState: {
        isShow: false,
        currentTime: 0,
        totalTime: 10,

        // 时长于像素间的换算比例
        unitConversion: 1,
        // 最大缩放比例
        maxUnitConversion: 10,
        // 最小缩放比例
        minUnitConversion: 0.1,
        // 最小宽度缩放比例
        minWidthScale: 1 / 5,
        // 最大宽度缩放比例
        maxWidthScale: (1 / 6) * 30,

        thumbnailBlobUrl: '',
        thumbnailImageUrl: '',
        sourceUrl: '',
        ratio: 9 / 16,
        title: '',
        isPlaying: false,
        subtitleList: [],
        startTime: 0,
        endTime: 890,
    },
    reducers: {
        setIsShow: (state, action) => {
            state.isShow = action.payload;
        },
        setTitle: (state, action) => {
            state.title = action.payload;
        },
        setSliceCurrentTime: (state, action) => {
            state.currentTime = action.payload;
        },
        setSliceTotalTime: (state, action) => {
            state.totalTime = action.payload;
        },
        setSliceUnitConversion: (state, action) => {
            state.unitConversion = action.payload;
        },
        setSliceMaxUnitConversion: (state, action) => {
            state.maxUnitConversion = action.payload;
        },
        setSliceMinUnitConversion: (state, action) => {
            state.minUnitConversion = action.payload;
        },

        setThumbnailBlobUrl: (state, action) => {
            state.thumbnailBlobUrl = action.payload;
        },
        setThumbnailImageUrl: (state, action) => {
            state.thumbnailImageUrl = action.payload;
        },
        setSourceUrl: (state, action) => {
            state.sourceUrl = action.payload;
        },
        setRatio: (state, action) => {
            state.ratio = action.payload;
        },
        setIsPlaying: (state, action) => {
            state.isPlaying = action.payload;
        },
        setStartTime: (state, action) => {
            state.startTime = action.payload;
        },
        setEndTime: (state, action) => {
            state.endTime = action.payload;
        },
        setSubtitleList: (state, action) => {
            state.subtitleList = action.payload;
        },
    },
});

export default FJCutVideoSlice;
